/* eslint-disable import/prefer-default-export */
export const DELIVERY_RECEIPTS_SRC_URL =
    process.env.REACT_APP_DELIVERY_RECEIPTS_SRC_URL;
